/**
 * Project color template — the single source of truth for every color in the UI.
 * Components must import from here; no color literals in component files.
 *
 * Primary: Material UI blue.
 */

/* ------------------------------------------------------------------ */
/* Brand / primary                                                     */
/* ------------------------------------------------------------------ */
export const BRAND_COLOR = "#1976D2"; // primary accent (buttons, icons, active nav)
export const BRAND_COLOR_DARK = "#1565C0"; // hover state for filled buttons
export const BRAND_COLOR_TINT = "rgba(25, 118, 210, 0.1)"; // icon tiles, active nav bg, chips, table heads
export const BRAND_COLOR_TINT_SOFT = "rgba(25, 118, 210, 0.05)"; // subtle hover backgrounds
export const BRAND_COLOR_TEXT = "#1565C0"; // readable accent text on tinted backgrounds

/* ------------------------------------------------------------------ */
/* Semantic status colors                                              */
/* ------------------------------------------------------------------ */
export const SUCCESS_COLOR = "#2e7d32"; // connected dots, check icons
export const SUCCESS_TEXT = "#1e6b21"; // text on success tint
export const SUCCESS_TINT = "rgba(102, 187, 106, 0.18)"; // success chip background

export const WARNING_COLOR = "#ed6c02"; // stop icons, caution accents
export const WARNING_TEXT = "#8a4a00"; // text on warning tint
export const WARNING_TINT = "rgba(255, 167, 38, 0.18)"; // warning chip background
export const WARNING_TINT_SOFT = "rgba(255, 249, 196, 0.8)"; // "In Progress" chip background

export const ERROR_COLOR = "#d32f2f"; // delete icons, destructive accents
export const ERROR_COLOR_DARK = "#b71c1c"; // hover state for destructive buttons
export const ERROR_BORDER = "rgba(211, 47, 47, 0.3)"; // danger-zone card border

/* ------------------------------------------------------------------ */
/* Text                                                                */
/* ------------------------------------------------------------------ */
export const TEXT_PRIMARY = "rgba(0, 0, 0, 0.87)"; // headings, titles
export const TEXT_SECONDARY = "rgba(0, 0, 0, 0.6)"; // body copy, descriptions
export const TEXT_MUTED = "rgba(0, 0, 0, 0.55)"; // captions, secondary labels
export const TEXT_FAINT = "rgba(0, 0, 0, 0.45)"; // hints, footers, tile labels
export const TEXT_DISABLED = "rgba(0, 0, 0, 0.38)"; // disabled nav/labels
export const TEXT_ON_DARK = "#fff"; // text/spinners on dark backdrops

/* ------------------------------------------------------------------ */
/* Surfaces & borders                                                  */
/* ------------------------------------------------------------------ */
export const SURFACE = "#fff"; // opaque cards / dialogs
export const SURFACE_TINT = "rgba(0, 0, 0, 0.02)"; // subtle tile backgrounds
export const SURFACE_OVERLAY = "rgba(255, 255, 255, 0.6)"; // translucent loader overlay
export const INFO_PANEL_BG = "rgba(83, 130, 161, 0.04)"; // DB Connection help panel
export const CHIP_NEUTRAL_BG = "rgba(0, 0, 0, 0.05)"; // neutral chip background

export const BORDER_LIGHT = "rgba(0, 0, 0, 0.08)"; // card / tile borders
export const BORDER = "rgba(0, 0, 0, 0.2)"; // outlined-button borders
export const BORDER_DARK = "rgba(0, 0, 0, 0.4)"; // outlined-button hover borders
export const DIVIDER = "rgba(232, 232, 232, 1)"; // sidebar / section dividers

/* ------------------------------------------------------------------ */
/* Shadows                                                             */
/* ------------------------------------------------------------------ */
export const CARD_SHADOW = "rgba(149, 157, 165, 0.2) 0px 8px 24px"; // resting card shadow
export const CARD_SHADOW_HOVER = "rgba(149, 157, 165, 0.2) 0px 6px 18px"; // card hover shadow
export const BUTTON_SHADOW = "0px 3px 1px -2px rgba(0, 0, 0, 0.20)"; // legacy raised-button shadow
